var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noData",style:({'height': _vm.height}),on:{"click":function($event){return _vm.onClickLayout()}}},[(_vm.isShowImage)?_c('img',{attrs:{"src":require("../assets/public/icon_no_data2.svg")}}):_vm._e(),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.text?_vm.text:_vm.$t("common.noDataHint")))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edcd7934","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-noData.vue
// module id = null
// module chunks = 